/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Dieser Dialog kommt ausschliesslich in der PWA-Version zum Einsatz.
 * Er dient dazu Videos anzuzeigen. In der iPad-Version 
 * wird ein Video über die Funktion cordova.viewVideo() gestartet.
 * 
 * Der Dialog wird sichtbar gemacht, wenn folgende Funktion aufgerufen wird: 
 * this.props.setModalDialog('MediaModal', url)
 * 
 */
import axios from 'axios';
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import db from '../../../basics/db';

import * as appActions from "../../../store/actions/appActions";
import { Icon } from '../../partials/Icons';

const styles = () => ({
    root: {
        '& .MuiDialogContent-root': {
            padding: 0,
            overflowY: 'none',
            backgroundColor: 'black'
        },
    }
});
class MediaModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'MediaModal';

        this.objectURL = null;
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate = async (prevProps) => {
        const { modalDialog, appModus } = this.props.app;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {
            if (appModus === 'Admin') {
                modalDialog.type.endsWith('mp4') && await this.fetchVideo();
            } else {
                modalDialog.type.endsWith('mp4') && await this.fetchVideo_IndexedDB();
            }
        }
    }

    // ==========================================================================
    //
    // VIDEO - SECTION
    //
    // ==========================================================================

    fetchVideo_IndexedDB = async () => {
        const { modalDialog, isSafari } = this.props.app;

        try {
            const dbfile = await db.video.where('name').equals(modalDialog.type).first()
            if (dbfile) {
                window.URL = window.URL || window.webkitURL;

                if (isSafari) {
                    const fileBlob = new Blob([dbfile.data], { type: 'video/mp4' });
                    this.objectURL = window.URL.createObjectURL(fileBlob);
                } else {
                    this.objectURL = window.URL.createObjectURL(dbfile.data)
                }

                const videoElement = document.getElementById('myVideo')
                const sourcesElement = videoElement.getElementsByTagName('source')
                sourcesElement[0].src = this.objectURL;
                videoElement.load();
                videoElement.play();
            } else {
                console.error(`Video [${modalDialog.type}] not found!`);
            }

        } catch (error) {
            console.error(`Error reading Video [${modalDialog.type}] from IndexedDB!`, error);
        }
    }

    fetchVideo = async () => {
        const { modalDialog, token, apiURL, currentContainer } = this.props.app;

        const url = encodeURI(apiURL + `/api/v1/file/${currentContainer}/common/${modalDialog.type}`);

        await axios({
            url: url
            , method: 'get'
            , timeout: 60 * 1000
            , headers: { 'authorization': token }
            , responseType: 'blob',
            onDownloadProgress: (progress) => {
                let currentProgress = 0;
                if (progress.total * progress.loaded !== 0) {
                    currentProgress = (100 / progress.total * progress.loaded);
                }
                this.setState({ currentProgress: currentProgress })
            }
        }).then(res => {
            const objectURL = window.URL.createObjectURL(res.data);
            const videoElement = document.getElementById('myVideo');
            const sourcesElement = videoElement.getElementsByTagName('source');
            sourcesElement[0].src = objectURL;
            videoElement.load();
            videoElement.play();

        }).catch((error) => {
            console.error(`can't load Video [${url}] from API!`, error);
        });
    }


    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog, windowHeight, headerHeight } = this.props.app;
        const { classes } = this.props;

        const height = windowHeight - headerHeight;

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        }

        const renderCancelButton = () => {

            return (
                <button className="inline-flex items-center focus:outline-none bg-transparent" onClick={onCancel}>
                    <Icon color={'white'} type='close2' width={40} height={40} />
                </button>
            )
        }

        const renderVideo = () => {
            const style = {
                height: height + 'px',
                minHeight: height + 'px'
            }

            return (
                <video id="myVideo" className="flex w-full" muted={false} preload="auto" autoPlay={true} controls style={style}>
                    <source src="" type="video/mp4" />
                </video>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        if (modalDialog.dialog !== this.component) return null;

        return (
            <Dialog className={classes.root} open={true} onClose={onCancel} fullScreen={true}>
                <DialogActions style={{ backgroundColor: 'black' }}>
                    <div className="flex-grow"></div>
                    {renderCancelButton()}
                </DialogActions>
                <DialogContent>{renderVideo()}</DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MediaModal));